/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { FunCode, FunCodeStock } from '@/api/types/user';
import ordersModule, { StoreUserCodeAdminOrdersState } from './orders';

export interface StoreUserCodeAdminState {
  codes: FunCode[];
  features: Record<string, string>;
  stocks: FunCodeStock[];
  // modules
  orders: StoreUserCodeAdminOrdersState;
}

export default {
  namespaced: true,
  modules: {
    orders: ordersModule,
  },
  state: {
    codes: [],
    features: [],
    stocks: [],
  },
  getters: {},
  actions: {
    [USER.GET_CODES]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getCodes().then((res) => {
          commit(USER.GET_CODES, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.GET_CODE_FEATURES]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getCodeFeatures().then((res) => {
          commit(USER.GET_CODE_FEATURES, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.GET_CODE_STOCKS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getCodeStocks().then((res) => {
          commit(USER.GET_CODE_STOCKS, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.SET_CODE_STOCK]({ dispatch }, { feature, lines }) {
      return new Promise((resolve, reject) => {
        api.setCodeStocks(feature, lines).then(() => {
          dispatch(USER.GET_CODE_STOCKS).then(resolve);
        }).catch(reject);
      });
    },
    [USER.CREATE_CODE]({ dispatch }, { body }) {
      return new Promise((resolve, reject) => {
        api.createCode(body).then(() => {
          dispatch(USER.GET_CODES).then(resolve);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_CODES](state: StoreUserCodeAdminState, codes) {
      state.codes = codes;
    },
    [USER.GET_CODE_FEATURES](state: StoreUserCodeAdminState, features) {
      state.features = features;
    },
    [USER.GET_CODE_STOCKS](state: StoreUserCodeAdminState, stocks) {
      state.stocks = stocks;
    },
  },
};
